import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'mw-search-student-layout',
  imports: [RouterOutlet],
  templateUrl: './search-student-layout.component.html',
  styleUrl: './search-student-layout.component.scss'
})
export class SearchStudentLayoutComponent {}
